import * as React from 'react';

const styles = require('./OptInScene.scss');
const classNames = require('classnames/bind').bind(styles);

function PhotoHubScene(props: {}) {
    return (
        <div>
            <div className={classNames('prop', 'fake-demonstrative-browser')}>
                <div className={classNames('prop', 'fake-web-app', 'emails')} />
                <div className={classNames('prop', 'fake-web-app', 'files')} />
                <div className={classNames('prop', 'nav-hover-highlight')} />
                <div className={classNames('prop', 'file-blockers')}>
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                    <i />
                </div>
            </div>
        </div>
    );
}
export default PhotoHubScene;
